/* unplugin-vue-components disabled */import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"

import "./Button.vue?vue&type=style&index=0&id=31b0ae12&lang=scss"

const __exports__ = script;

export default __exports__